import React from 'react';
import WhyCompaniesChooseUs from '../../components/single-role-components/WhyCompaniesChooseUs';
import {useParams} from 'react-router-dom';
import InitialRoleSection from '../../components/single-role-components/Initial';
import {rolePageData} from './role-page-data';
import PermworksByTheNumbers from '../../components/single-role-components/PermworksByTheNumbers';
import Footer from '../../components/Footer/Footer';
import {permColors} from '../../utils/colors';
import HowItWorksSection from '../../components/single-role-components/HowItWorksSection';
import SummarySection from '../../components/single-role-components/SummarySection';
import ComparisonTable from '../../components/single-role-components/ComparisonTable';
import FaqSection from '../../components/single-role-components/FaqSection';
import TrustedBy from '../../components/single-role-components/TrustedBy';
import SquareCta from '../../components/single-role-components/SquareCta';
import Testimonials from '../../components/single-role-components/Testimonials';
import {CandidateSection} from '../../components/single-role-components/CandidateCards';
export default function RolePage() {
	const {roleName} = useParams();
	const roleSection = rolePageData.find((data) => data.role === roleName);

	return (
		<div>
			<InitialRoleSection
				h1={roleSection.initialSection.h1}
				pArray={roleSection.initialSection.pArray}
				image={roleSection.initialSection.image}
				imageAlt={roleSection.initialSection.imageAlt}
				h2={roleSection.initialSection.h2}
				buttonText={roleSection.initialSection.buttonText}
			/>
			<TrustedBy />

			<PermworksByTheNumbers />
			<CandidateSection title={roleSection.candidateSection.title} subtitle={roleSection.candidateSection.subtitle} candidates={roleSection.candidateSection.candidates} />
			<SummarySection h3={roleSection.summarySection.h3} p={roleSection.summarySection.p} />
			<HowItWorksSection />
			<ComparisonTable />
			<WhyCompaniesChooseUs />
			<Testimonials />
			<FaqSection faqs={roleSection.faqSection.faqs} title={roleSection.faqSection.title} />
			<SquareCta text={roleSection.squareCta.cardText} />
			<Footer backgroundColor={permColors.white} />
		</div>
	);
}
